exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vc-form-group[data-v-06ac4a8b]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;padding:5px 0;-webkit-box-sizing:border-box;box-sizing:border-box;-ms-flex-wrap:wrap;flex-wrap:wrap;width:100%;position:relative;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", ""]);

// exports
